<template>
  <div>
    <el-carousel
      :interval="5000"
      arrow="never"
      :height="bannerHeight + 'px'"
      indicator-position="none"
    >
      <el-carousel-item
        v-for="item in bannerList"
        :key="item"
      >
        <img
          :style="'height:'+bannerHeight+'px'"
          ref="bannerHeight"
          :src="item"
          class="swiper_banner"
        >
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  props: {
    bannerList: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      bannerHeight: 0,
      screenWidth: 0
    }
  },
  mounted () {
    this.setSize1();
    const that = this;
    //监听浏览器窗口大小改变
    window.addEventListener('resize', function () {
      that.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      that.setSize();
    }, false);
  },
  methods: {
    setSize1: function () {
      this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      this.screenWidth = this.screenWidth < 1300 ? 1300 : this.screenWidth;
      this.bannerHeight = 560 / 1920 * this.screenWidth
    },
    setSize: function () {
      this.screenWidth = this.screenWidth < 1300 ? 1300 : this.screenWidth;
      console.log(this.screenWidth)
      this.bannerHeight = 560 / 1920 * this.screenWidth
    }
  }
}
</script>

<style scoped>
.swiper_banner {
  width: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/banner/index.vue